module.exports = __webpack_public_path__ + "static/media/calendar-times.85b75338.svg";